import { useLenisStore } from '~/stores/LenisStore'

export default function () {
  const store = useLenisStore()
  const isLocked = useState('bodyLock')

  function bodyLock() {
    if (store.lenis) {
      store.lenis.stop()
      isLocked.value = true
    }
  }

  function bodyUnlock() {
    if (store.lenis) {
      store.lenis.start()
      isLocked.value = false
    }
  }

  return {
    bodyLock,
    bodyUnlock
  }
}
